import React, { useState } from "react";
import Overview from "./pages/Overview";
import Portfolio from "./pages/Portfolio";
import TradeBook from "./pages/TradeBook";

const UNIVERSES = ["Nifty 100", "Nifty 200", "Nifty 500"];

export default function AlphaDashboardView() {
  const [universe, setUniverse] = useState("Nifty 100");
  const [page, setPage] = useState("overview");

  return (
    <div className="flex flex-col h-full w-full bg-[#0f1116] text-gray-100 overflow-hidden rounded-xl border border-gray-800 shadow-xl">
      {/* Optimus-styled Sub-Header Bar */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-800 bg-[#1a1d29] px-6 py-3 shrink-0 gap-4">
        {/* View Tabs */}
        <div className="flex items-center gap-2">
          <button
            className={`px-5 py-2 text-sm font-semibold transition-all rounded-lg cursor-pointer ${
              page === "overview"
                ? "bg-blue-600 text-white shadow-md"
                : "text-gray-400 hover:text-gray-200 hover:bg-gray-800/60"
            }`}
            onClick={() => setPage("overview")}
          >
            Overview
          </button>
          <button
            className={`px-5 py-2 text-sm font-semibold transition-all rounded-lg cursor-pointer ${
              page === "portfolio"
                ? "bg-blue-600 text-white shadow-md"
                : "text-gray-400 hover:text-gray-200 hover:bg-gray-800/60"
            }`}
            onClick={() => setPage("portfolio")}
          >
            Portfolio
          </button>
          <button
            className={`px-5 py-2 text-sm font-semibold transition-all rounded-lg cursor-pointer ${
              page === "tradebook"
                ? "bg-blue-600 text-white shadow-md"
                : "text-gray-400 hover:text-gray-200 hover:bg-gray-800/60"
            }`}
            onClick={() => setPage("tradebook")}
          >
            Trade Book
          </button>
        </div>

        {/* Universe Selector Pills */}
        <div className="flex items-center gap-1.5 bg-[#0f1116] p-1 rounded-lg border border-gray-800">
          <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider px-2">Universe:</span>
          {UNIVERSES.map((u) => (
            <button
              key={u}
              onClick={() => setUniverse(u)}
              className={`px-3 py-1 text-xs font-mono font-semibold rounded-md transition-all cursor-pointer ${
                universe === u
                  ? "bg-amber-600 text-white shadow-sm"
                  : "text-gray-400 hover:text-gray-200 hover:bg-gray-800/50"
              }`}
            >
              {u}
            </button>
          ))}
        </div>
      </div>

      {/* Main Scrollable Content Container */}
      <div className="flex-1 overflow-hidden p-6 relative bg-[#0f1116]">
        {page === "overview" && <Overview universe={universe} />}
        {page === "portfolio" && <Portfolio universe={universe} />}
        {page === "tradebook" && <TradeBook universe={universe} />}
      </div>
    </div>
  );
}
